'use client';

import React from 'react';
import { Tooltip } from 'antd';
import { FiCopy } from 'react-icons/fi';
import ThemedButton from '@/components/common/buttons/Button';
import { copyToClipboard } from '../utils';

interface SecurityCodeCardProps {
  title: string;
  value?: string | null;
}

const SecurityCodeCard = ({ title, value }: SecurityCodeCardProps) => (
  <div
    style={{
      border: '1px solid var(--color-primary)',
      borderLeft: '4px solid var(--color-primary)',
      background: 'rgba(59, 130, 246, 0.06)',
      padding: '16px 18px',
    }}
  >
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 10,
      }}
    >
      <span
        style={{
          fontSize: 11,
          fontWeight: 700,
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          color: 'var(--primary-color)',
        }}
      >
        {title}
      </span>

      {value && (
        <Tooltip title={`Copy ${title}`}>
          <ThemedButton
            size="small"
            variant="outlined"
            theme="secondary"
            text=""
            icon={<FiCopy size={12} />}
            onClick={() => copyToClipboard(title, value)}
          />
        </Tooltip>
      )}
    </div>

    <div
      style={{
        background: 'rgba(59, 130, 246, 0.10)',
        border: '1px solid var(--color-primary)',
        borderRadius: 0,
        padding: '10px 14px',
      }}
    >
      <code
        style={{
          fontSize: 15,
          fontWeight: 800,
          letterSpacing: '0.1em',
          color: 'var(--color-accent)',
          display: 'block',
          wordBreak: 'break-all',
        }}
      >
        {value || '—'}
      </code>
    </div>

    <div
      style={{
        marginTop: 8,
        fontSize: 11,
        color: 'var(--color-primary)',
        fontStyle: 'italic',
      }}
    >
      Confirm this code matches the one printed on the original document.
    </div>
  </div>
);

export default SecurityCodeCard;
